import React,{useState,useEffect,useRef, useContext} from 'react';
import {Container,Row,Col,Form} from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import '../../pages/Dashboard/dashboard.css';
import { BoxVentas,BoxMetas, TablaAgentes, TablaFlotillas,GraficaPeriodo,CarteraIndividual, CarteraFlotillas, SegmentacionCartera, SegmentacionCarteraOficina, CarteraIndividualOficina, CarteraFlotillasOficina, BoxMetasOficina, TablaReservaPendientesCobertura, TablaReservaPendientesMarca } from '../../Components/Components';
import { Link, useHistory,useRouteMatch,useParams} from "react-router-dom";
import { IconBack } from '../../Components/Icons';
import { AuthContext } from '../../auth/AuthContext';
import { SelectAgente, SelectTypeAgente } from '../../Components/SelectGroup/SelectGroup';

export const ViewOficina = ({initState,updateState}) => {

  // GET ID FROM PARAMS
  const {id} = useParams();
  const history = useHistory();
  const {usuario} = useContext(AuthContext)

  const ref = useRef(null);
  const currentYear = new Date().getFullYear();
  const beforeYear = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).getFullYear();

  const [selectedAgentes, setSelectedAgentes] = useState('0');
  const [selectedTipos, setSelectedTipos] = useState('0');

  const [dataOficina,setDataOficina] = useState([]);
  const [datosMetas,setDatosMetas] = useState([]);
  const {openMenu, data, loadingData,profileOficinas,profileOficinasAgentes,viewOficinaData} = initState;
  const [isSticky, setSticky] = useState(false);
  const [loadSelect,setLoadSelect] = useState(false);
  const [loadDatagraficaTipo,setLoadDataGraficaTipo] = useState(false);
  const [loadDataAgentes,setLoadDataAgentes] = useState(false);
  const [loadSegmentacionCartera,setLoadSegmentacionCartera] = useState(false)
  const [loadCarteraIndividual,setLoadCarteraIndividual] = useState(false)
  const [loadCarteraFlotillas,setLoadCarteraFlotillas] = useState(false)

  const [dataRpCobertura,setDataRpCobertura] = useState([]);
  const [dataRpMarca,setDataRpMarca] = useState([]);

  const {
    ventasMonthCurrent         = [],
    ventasYearCurrent          = [],
    ventasYearBefore           = [],
    ventasLast12Months         = [],
    siniestralidadMonthCurrent = [],
    siniestralidaLast12Months  = [],
    nombre_oficina             = "",
  } = dataOficina;

  const handleScroll = () => {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrolled = winScroll / height;
    scrolled>0 ? setSticky(true) : setSticky(false) 
  };

  //show shadow on sticky header select
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', () => handleScroll);
    };
  }, [])

  useEffect(() => {

    if(loadSelect) {
      updateState({ loadingData: true });
      getProfileOficina();
    }else{
      if(profileOficinas.length===0) {
        updateState({ loadingData: true });
        getProfileOficina();
      }else{
        const isData = profileOficinas.find(element => element.id === id);
        if(!isData) {
          updateState({ loadingData: true });
          getProfileOficina();
        }else{
          setDataOficina(isData);
          setDataRpCobertura(isData.reserva_pendiente_por_cobertura);
          setDataRpMarca(isData.reserva_pendiente_por_marca);
        }
      }
    }
    
  },[selectedAgentes,selectedTipos])

  useEffect(() => {
    getDesgloseMetaOficina();
  },[])

  const handleChangeAgentes = (e) => {
    setLoadSelect(true); 
    setLoadDataGraficaTipo(true)
    setLoadDataAgentes(true)
    setSelectedAgentes(e.target.value);
    viewOficinaData.agentes = e.target.value;
    updateState({
      viewOficinaData
    })
  }

  const handleChangeAgentesTipos = (e) => {
    setLoadSelect(true); 
    setLoadDataGraficaTipo(true)
    setLoadDataAgentes(true)
    setSelectedTipos(e.target.value);
    viewOficinaData.tipo_agente = e.target.value;
    updateState({
      viewOficinaData
    })
  }

  return (
    <>
      <div className={`ws_content_wrapper ${(!openMenu) ? 'wrapper_close' : ''}`}>
        <div className="ws_content_header ws_pl_0 ws_pr_0 mb-5">
  
          <Container fluid className={`ws_header_fixed ${isSticky ? 'shadow' : ''} mt-st-7`} ref={ref} style={{borderBottom:'1px solid #ccc'}}>
            <Row>
              <Col className="mb-2" xs={12} md={3}>
                {
                  (!loadingData) 
                    ? <><span className="ws_title_header" style={{cursor:'pointer'}} onClick={ (e) => { history.goBack(); }} ><IconBack widht="20px" height="20px" className="pe-2" />{nombre_oficina}</span></>
                    : <Skeleton />
                }
              </Col>
              <Col className="mb-2" xs={12} md={9}>
                <Row>
                  {/* <SelectAgente
                  className="ws_select_opt" 
                  value={selectedAgentes} 
                  onChange={ handleChangeAgentes } 
                  /> */}
                  <SelectTypeAgente 
                  className="ws_select_opt"
                  value={selectedTipos}
                  onChange={ handleChangeAgentesTipos }
                  />
                </Row>
              </Col>
            </Row>
          </Container>

          <Container fluid className="mt-5">
            <Row>
              <BoxVentas state={initState} updateState={updateState} loading={loadingData} tagColor={ventasMonthCurrent.color} title={ventasMonthCurrent.titulo} value={"$" + number_format(ventasMonthCurrent.valor, 2)} percent={ventasMonthCurrent.porcentaje} date={ventasMonthCurrent.subtitulo} />
              <BoxVentas state={initState} updateState={updateState} loading={loadingData} tagColor={ventasYearBefore.color} title={ventasYearBefore.titulo} value={"$" + number_format(ventasYearBefore.valor, 2)} percent={ventasYearBefore.porcentaje} date={ventasYearBefore.subtitulo} />
              <BoxVentas state={initState} updateState={updateState} loading={loadingData} tagColor={ventasYearCurrent.color} title={ventasYearCurrent.titulo} value={"$" + number_format(ventasYearCurrent.valor, 2)} percent={ventasYearCurrent.porcentaje} date={ventasYearCurrent.subtitulo} />
              <BoxVentas state={initState} updateState={updateState} loading={loadingData} tagColor={ventasLast12Months.color} title={ventasLast12Months.titulo} value={"$" + number_format(ventasLast12Months.valor, 2)} percent={ventasLast12Months.porcentaje} date={ventasLast12Months.subtitulo} />
              <BoxVentas state={initState} updateState={updateState} loading={loadingData} tagColor={siniestralidadMonthCurrent.color} title={siniestralidadMonthCurrent.titulo} value={siniestralidadMonthCurrent.valor + "%"} percent={siniestralidadMonthCurrent.porcentaje} date={siniestralidadMonthCurrent.subtitulo} />
              <BoxVentas state={initState} updateState={updateState} loading={loadingData} tagColor={siniestralidaLast12Months.color} title={siniestralidaLast12Months.titulo} value={siniestralidaLast12Months.valor + "%"} percent={siniestralidaLast12Months.porcentaje} date={siniestralidaLast12Months.subtitulo} />
            </Row>
            <Row>
              <GraficaPeriodo 
              state={initState} 
              updateState={updateState} 
              year={currentYear} 
              selected={currentYear} 
              loadDatagraficaTipo={loadDatagraficaTipo}
              setLoadDataGraficaTipo={setLoadDataGraficaTipo}
              dataSelect={{
                selectedOficinas  : [id],
                selectedAgentes: selectedAgentes,
                selectedTipos  : selectedTipos,
              }}
              />
              <GraficaPeriodo 
              state={initState}
              updateState={updateState} 
              year={currentYear} 
              selected={beforeYear} 
              loadDatagraficaTipo={loadDatagraficaTipo}
              setLoadDataGraficaTipo={setLoadDataGraficaTipo}
              dataSelect={{
                selectedOficinas  : [id],
                selectedAgentes: selectedAgentes,
                selectedTipos  : selectedTipos,
              }}
              />
              <BoxMetasOficina idOficina={id} datosMetas={datosMetas} size={{xs:12,sm:12,md:12,lg:12}} reload={getDesgloseMetaOficina} />
            </Row>
            <Row>

              <TablaReservaPendientesCobertura 
              initState={initState} 
              updateState={updateState} 
              data={ dataRpCobertura } 
              loadData={ loadingData } 
              size={{xl:6,xxl:6}} 
              dataSelect={{
                id : id,
              }}
              type="Oficina"
              />
              
              <TablaReservaPendientesMarca 
              initState={initState} 
              updateState={updateState} 
              data={ dataRpMarca } 
              loadData={ loadingData } 
              size={{xl:6,xxl:6}}
              dataSelect={{
                id : id,
              }}
              type="Oficina"
              />
   
              <TablaAgentes 
              initState={initState}
              updateState={updateState}
              loadDataAgentes={loadDataAgentes}
              setLoadDataAgentes={setLoadDataAgentes}
              dataSelect={{
                clave_oficina  : id,
                selectedAgentes: selectedAgentes,
                selectedTipos  : selectedTipos,
              }}
              />
            </Row>
            <Row>
              <SegmentacionCarteraOficina 
              loadSegmentacionCartera={loadSegmentacionCartera}
              setLoadSegmentacionCartera={setLoadSegmentacionCartera}
              dataOficina={{
                clave_oficina: id,
              }}
              initState={initState} 
              updateState={updateState}
              />
              <CarteraIndividualOficina
              loadCarteraIndividual={loadCarteraIndividual}
              setLoadCarteraIndividual={setLoadCarteraIndividual}
              dataOficina={{
                clave_oficina: id,
              }}
              initState={initState} 
              updateState={updateState}
              />
              <CarteraFlotillasOficina
              loadCarteraFlotillas={loadCarteraFlotillas}
              setLoadCarteraFlotillas={setLoadCarteraFlotillas}
              dataOficina={{
                clave_oficina: id,
              }}
              initState={initState} 
              updateState={updateState}
              />
            </Row>
          </Container>
        </div>
      </div>
    </>
  )

  function getProfileOficina() {
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getProfileOficina`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({
        id_login: usuario.id_usuario,
        clave_oficina:id,
        agentes:viewOficinaData.agentes,
        tipo_agente:viewOficinaData.tipo_agente
      }),
    })
    .then(res => res.json())
    .then((res) => {
      setDataRpCobertura(res.reserva_pendiente_por_cobertura);
      setDataRpMarca(res.reserva_pendiente_por_marca);
      res.id = id;
      const isSet = profileOficinas.find(element => element.id === id);
      if(isSet) {
        const indexP = profileOficinas.findIndex(element => element.id === id);
        profileOficinas[indexP] = res;
        updateState({ loadingData: false, profileOficinas });
        setDataOficina(res)
      }else{
        updateState({ loadingData: false, profileOficinas: profileOficinas.concat(res) });
        setDataOficina(res)
      }
      
    })
  }

  function getDesgloseMetaOficina(){
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getDesgloseMetaOficina`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({
        id_login: usuario.id_usuario,
        clave_oficina:id,
      }),
    })
    .then(res => res.json())
    .then((res) => {
      setDatosMetas(res.list)
    })
  }

  //FORMATO EN NÚMEROS
  function number_format(number, decimals, decPoint, thousandsSep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return '' + (Math.round(n * k) / k)
        .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length + 1).join('0')
    }
    return s.join(dec)
  }
}
